import { Address } from '@/shared/lib/forms/form-wrapper.types';

import { getCountryName } from '../dictionaries/countries';

export const getAddressDisplay = (value: Address | undefined, placeholder = '') => {
  if (!value) return placeholder;

  const parts = [
    getCountryName(value.country),
    value.zipCode,
    value.district,
    value.city,
    value.street,
    value.buildingNumber,
    value.apartment,
  ].filter(Boolean);

  return parts.join(', ');
};
